/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/blocks/quote.scss';

const propTypes = {
    quote: PropTypes.string,
    author: PropTypes.string,
    isLast: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    quote: null,
    author: null,
    isLast: false,
    className: null,
};

const QuoteBlock = ({ quote, author, isLast, className }) => {
    return (
        <div
            className={classNames({
                [styles.container]: true,
                [styles.isLast]: isLast,
                [className]: className !== null,
            })}
        >
            <div className={styles.inner}>
                <div className={styles.quote}>« {quote} »</div>
                <div className={styles.author}>- {author}</div>
            </div>
        </div>
    );
};

QuoteBlock.propTypes = propTypes;
QuoteBlock.defaultProps = defaultProps;

export default QuoteBlock;
